/*@flow*/
import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import PiwikReactRouter from 'piwik-react-router';

import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { store } from './configureStore';
import history from './history';
import { piwikConfig } from './config';

import './querySyncer';
import './index.css';

const rootElement = document && document.getElementById('root');
if (!(rootElement instanceof Element)) {
  throw new Error('Invalid DOM Element');
}

const piwik = PiwikReactRouter(piwikConfig);

ReactDOM.render(
  <Provider store={store}>
    <Router history={piwik.connectToHistory(history)}>
      <App />
    </Router>
  </Provider>,
  rootElement
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js